import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  errorApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  ALL_RELATIONS,
  ALL_RELATION_PAIRS,
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
} from '@backstage/plugin-catalog-graph';
import { VisitsWebStorageApi, visitsApiRef } from '@backstage/plugin-home';

const catalogGraphApi = createApiFactory({
  api: catalogGraphApiRef,
  deps: {},
  factory: () =>
    new DefaultCatalogGraphApi({
      knownRelationPairs: [
        ...ALL_RELATION_PAIRS,
        // scaffolder relations are from https://github.com/backstage/community-plugins/tree/main/workspaces/scaffolder-relation-processor
        ['scaffolderOf', 'scaffoldedFrom'],
      ],
      knownRelations: [...ALL_RELATIONS, 'scaffolderOf', 'scaffoldedFrom'],
      defaultRelationTypes: {
        exclude: [],
      },
    }),
});

export const defaultApis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: visitsApiRef,
    deps: {
      identityApi: identityApiRef,
      errorApi: errorApiRef
    },
    factory: ({ identityApi, errorApi }) =>
      VisitsWebStorageApi.create({ identityApi, errorApi }),
  }),
  catalogGraphApi,
];
